var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12395",
    "data-name": "Group 12395",
    transform: "translate(-10 -699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12386",
    "data-name": "Group 12386",
    transform: "translate(26.364 715.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13000",
    "data-name": "Path 13000",
    d: "M2062.411,818.558a6.337,6.337,0,1,0-4.481,10.819h0a6.337,6.337,0,0,0,4.481-10.819ZM2059.891,825a2.753,2.753,0,0,1-1.96.812h0a2.773,2.773,0,1,1,1.96-.812Z",
    transform: "translate(-2011.86 -801.987)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12382",
    "data-name": "Group 12382",
    transform: "translate(0 41.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13001",
    "data-name": "Path 13001",
    d: "M1864.706,955.724a1.783,1.783,0,0,1-1.26-3.043l10.307-10.306a1.782,1.782,0,0,1,2.521,2.521L1865.968,955.2A1.779,1.779,0,0,1,1864.706,955.724Z",
    transform: "translate(-1862.924 -941.852)",
    fill: "#2eafbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12383",
    "data-name": "Group 12383",
    transform: "translate(2.304 50.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13002",
    "data-name": "Path 13002",
    d: "M1875.648,1000.984a1.783,1.783,0,0,1-1.26-3.043l10.743-10.743a1.782,1.782,0,0,1,2.521,2.521l-10.743,10.742A1.777,1.777,0,0,1,1875.648,1000.984Z",
    transform: "translate(-1873.866 -986.676)",
    fill: "#2eafbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12384",
    "data-name": "Group 12384",
    transform: "translate(12.18 53.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13003",
    "data-name": "Path 13003",
    d: "M1922.543,1013.561a1.782,1.782,0,0,1-1.26-3.042l10.307-10.307a1.782,1.782,0,0,1,2.52,2.521L1923.8,1013.04A1.779,1.779,0,0,1,1922.543,1013.561Z",
    transform: "translate(-1920.761 -999.69)",
    fill: "#2eafbe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13004",
    "data-name": "Path 13004",
    d: "M1943.176,747.353a1.781,1.781,0,0,0-1.543-.5,65.908,65.908,0,0,0-11.88,3.417,72.206,72.206,0,0,0-11.153,5.371,58.839,58.839,0,0,0-11.282,8.645l-13.461,2.621a1.786,1.786,0,0,0-.918.487l-12.2,12.156A1.782,1.782,0,0,0,1882,782.6a1.86,1.86,0,0,0,.341-.032l13.756-2.679q-1.344,2.636-2.511,5.472a1.783,1.783,0,0,0,.388,1.938l3.37,3.37-3.131,3.131a1.783,1.783,0,0,0,2.521,2.521l3.13-3.131,3.37,3.37a1.78,1.78,0,0,0,1.938.388q2.836-1.166,5.47-2.51l-2.677,13.756a1.782,1.782,0,0,0,3.011,1.6l12.156-12.2a1.788,1.788,0,0,0,.488-.918l2.62-13.461a58.834,58.834,0,0,0,8.646-11.283,72.366,72.366,0,0,0,5.371-11.154,66.06,66.06,0,0,0,3.417-11.88A1.785,1.785,0,0,0,1943.176,747.353ZM1887.4,777.946l7.668-7.643,8.25-1.606a60.944,60.944,0,0,0-4.972,7.119Zm32.824,17.513-7.644,7.668,2.131-10.945a60.872,60.872,0,0,0,7.119-4.973ZM1936.9,759.59a61.845,61.845,0,0,1-13.385,21.317,55.139,55.139,0,0,1-11.188,8.548,1.714,1.714,0,0,0-.218.129,67.733,67.733,0,0,1-7.2,3.6l-2.523-2.523,5.092-5.091a1.782,1.782,0,0,0-2.52-2.521l-5.092,5.091-2.522-2.522a67.57,67.57,0,0,1,3.6-7.2,1.8,1.8,0,0,0,.127-.216,55.086,55.086,0,0,1,8.549-11.189,61.817,61.817,0,0,1,21.316-13.384,70.807,70.807,0,0,1,8.665-2.71A70.911,70.911,0,0,1,1936.9,759.59Z",
    transform: "translate(-1876.576 -746.831)",
    fill: "#2eafbe"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 100,
    height: 100,
    transform: "translate(10 699)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-icon.5e5371d2c262b82b3d8de990e495fdb1.svg";
export { ForwardRef as ReactComponent };